import * as React from "react";
import { Context } from "./_context";
export const MapIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20.645 2.565A1 1 0 0 1 22 3.5v14.223a1 1 0 0 1-.645.934l-6 2.278-.086.029a1 1 0 0 1-.623-.03L9 18.792l-5.646 2.144A1 1 0 0 1 2 20V5.777a1 1 0 0 1 .506-.869l.14-.065 6-2.278a1 1 0 0 1 .623-.029l.085.03L15 4.707l5.645-2.143ZM4 6.468V18.55l4-1.52V4.948l-4 1.52Zm6 10.563 4 1.52V6.468l-4-1.52v12.083Zm6-10.563V18.55l4-1.52V4.948l-4 1.52Z", fill: "currentColor" }));
  return iconset[size];
};
MapIcon.iconId = "cPpVvs";
